{
	"name": "@zenfs/core",
	"version": "2.6.3",
	"description": "A filesystem, anywhere",
	"funding": {
		"type": "individual",
		"url": "https://github.com/sponsors/james-pre"
	},
	"main": "dist/index.js",
	"types": "dist/index.d.ts",
	"keywords": [
		"filesystem",
		"node",
		"storage"
	],
	"bin": {
		"make-index": "scripts/make-index.js",
		"zenfs-test": "scripts/test.js",
		"zci": "scripts/ci-cli.js"
	},
	"files": [
		"dist",
		"tests",
		"types",
		"license.md",
		"eslint.shared.js"
	],
	"type": "module",
	"homepage": "https://zenfs.dev/core",
	"author": "James Prevett <jp@jamespre.dev> (https://jamespre.dev)",
	"contributors": [
		"John Vilk <jvilk@cs.umass.edu>"
	],
	"license": "LGPL-3.0-or-later",
	"repository": {
		"type": "git",
		"url": "git+https://github.com/zen-fs/core.git"
	},
	"bugs": {
		"url": "https://github.com/zen-fs/core/issues"
	},
	"engines": {
		"node": ">= 18"
	},
	"exports": {
		".": "./dist/index.js",
		"./*": "./dist/*",
		"./emulation/*": "./dist/node/*",
		"./promises": "./dist/node/promises.js",
		"./readline": "./dist/node/readline.js",
		"./constants": "./dist/constants.js",
		"./path": "./dist/path.js",
		"./eslint": "./eslint.shared.js",
		"./tests/*": "./tests/*",
		"./types/*": "./types/*"
	},
	"publishConfig": {
		"access": "public",
		"provenance": true
	},
	"scripts": {
		"format": "prettier --write .",
		"format:check": "prettier --check .",
		"spdx:check": "npx lice -a src tests/*.ts tests/**/*.test.ts",
		"spdx:fix": "npx lice -aw src tests/*.ts tests/**/*.test.ts",
		"lint": "eslint src tests",
		"test": "npx --silent zenfs-test --clean; npx --silent zenfs-test -abcp; tests/fetch/run.sh; npx --silent zenfs-test --report",
		"build": "tsc -p tsconfig.json",
		"build:docs": "typedoc",
		"dev": "tsc -p tsconfig.json --watch",
		"prepublishOnly": "npm run build"
	},
	"dependencies": {
		"@types/node": "^26.0.0",
		"buffer": "^6.0.3",
		"eventemitter3": "^5.0.1",
		"kerium": "^1.4.2",
		"memium": "^1.0.0",
		"readable-stream": "^4.5.2",
		"utilium": "^3.0.0"
	},
	"devDependencies": {
		"@eslint/js": "^10.0.1",
		"@octokit/action": "^8.0.4",
		"c8": "^12.0.0",
		"eslint": "^10.1.0",
		"globals": "^17.3.0",
		"prettier": "^3.2.5",
		"tsx": "^4.19.1",
		"typedoc": "^0.28.18",
		"typescript": "^6.0.0",
		"typescript-eslint": "^8.58.0"
	},
	"allowScripts": {
		"esbuild": true
	}
}
